import api from '../config/api';

const userService = {
  async getAll() {
    const response = await api.get('/api/admin/users');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/api/admin/users/${id}`);
    return response.data;
  },

  async create(userData) {
    const response = await api.post('/api/admin/users', userData);
    return response.data;
  },

  async update(id, userData) {
    const response = await api.post(`/api/admin/users/${id}/update`, userData);
    return response.data;
  },
};

export default userService;
